import { useServerState } from "@project-mgmt/api-client";
import { createHeaders } from "@project-mgmt/api-client";
export function useNotifications(workspaceId) {
    return useServerState({
        key: ["notifications", workspaceId],
        fetcher: async (signal) => {
            const response = await fetch(`/api/notifications`, {
                signal,
                headers: createHeaders(workspaceId),
            });
            if (!response.ok) {
                throw new Error("Failed to fetch notifications");
            }
            return response.json();
        },
        enabled: !!workspaceId, // Only fetch when workspaceId is available
    });
}
export function useUnreadNotificationsCount(workspaceId) {
    return useServerState({
        key: ["notifications", "unread-count", workspaceId],
        fetcher: async (signal) => {
            const response = await fetch("/api/notifications/unread-count", {
                signal,
                headers: createHeaders(workspaceId),
            });
            if (!response.ok) {
                throw new Error("Failed to fetch unread count");
            }
            return response.json();
        },
        enabled: !!workspaceId, // Only fetch when workspaceId is available
    });
}
